import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TextField from 'components/formik/TextField';
import { Field } from 'formik';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';

const getStyles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  description: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
});

const SlackConfig = () => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <>
      <Typography sx={styles.heading}>{I18n.t('ChatFlowSettings.Webhook URL')}</Typography>
      <Typography sx={styles.description}>
        {I18n.t('ChatFlowSettings.Slack incoming webhook URL')}
      </Typography>
      <Field
        component={TextField}
        name="configuration.webhookUrl"
        type="url"
        pattern="https://.*"
        placeholder="https://hooks.slack.com/services/..."
      />

      <Typography sx={styles.heading}>{I18n.t('ChatFlowSettings.Channel')}</Typography>
      <Typography sx={styles.description}>
        {I18n.t('ChatFlowSettings.Optional channel (defaults to webhook default)')}
      </Typography>
      <Field component={TextField} name="configuration.channel" placeholder="#general" />
    </>
  );
};

export default SlackConfig;
